<template>
  <Modal ref="modal" :title="title">
    <div v-if="loading" class="text-center p-4">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else-if="error" class="alert alert-danger">
      {{ error }}
    </div>
    <div v-else>
      <div class="row g-3 mb-4">
        <div class="col-md-6">
          <div class="card p-3 text-center">
            <div class="text-muted">
              {{ $t("incomeStatement.totalIncome") }}
            </div>
            <div class="value">{{ formatCurrency(data.total_income) }}</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card p-3 text-center">
            <div class="text-muted">
              {{ $t("incomeStatement.totalExpense") }}
            </div>
            <div class="value negative">
              {{ formatCurrency(data.total_expense) }}
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="text-start">{{ $t("incomeStatement.category") }}</th>
              <th class="text-end">Income</th>
              <th class="text-end">Expense</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data.delivery_methods" :key="index">
              <td class="text-start">{{ item.name }}</td>
              <td class="text-end">{{ formatCurrency(item.income) }}</td>
              <td class="text-end negative">
                {{ formatCurrency(item.expense) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "./Modal.vue";
import http from "@/modules/http";

export default {
  name: "ShippingDetailModal",
  components: { Modal },
  data() {
    return {
      loading: false,
      error: null,
      data: {
        total_income: 0,
        total_expense: 0,
        delivery_methods: [],
      },
      currency: "HUF",
    };
  },
  computed: {
    title() {
      return this.$t("incomeStatement.shippingDetails") || "Shipping Details";
    },
  },
  methods: {
    show(rowKey) {
      this.$refs.modal.showModal();
      this.loadData(rowKey);
    },
    hide() {
      this.$refs.modal.hideModal();
    },
    loadData(rowKey) {
      this.loading = true;
      this.error = null;

      const from = this.$store.state.topBar.date[0].toISOString().split("T")[0];
      const to = this.$store.state.topBar.date[1].toISOString().split("T")[0];

      http
        .fetch(
          `/income-statement/shipping-details?from=${from}&to=${to}&key=${rowKey}`
        )
        .then((data) => {
          this.data = data;
          this.currency = data.currency || "HUF";
        })
        .catch((err) => {
          this.error = err.message || "Failed to load data";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return "";
      return new Intl.NumberFormat("hu-HU", {
        style: "currency",
        currency: this.currency,
        maximumFractionDigits: 0,
      }).format(value);
    },
  },
};
</script>

<style scoped>
.value {
  font-size: 1.4rem;
  font-weight: 700;
}
.positive {
  color: #16a34a;
}
.negative {
  color: #dc2626;
}
</style>
